/**
 * The company work week, for the UI.
 *
 * Saturday and Sunday are both weekly offs: they are disabled in the leave date
 * pickers, greyed out in the calendar, and never counted as leave days.
 *
 * This mirrors src/backend_routes/utils/workweek.js — the server is the
 * authority, this copy only exists so the UI can grey a date out without a
 * round trip. Keep the two in step.
 */

// JS getDay(): 0 = Sunday … 6 = Saturday
export const WEEKEND_DOW = [0, 6];

/** True for Saturday and Sunday. Accepts a Date. */
export const isWeekend = (date) => WEEKEND_DOW.includes(date.getDay());

/** Label used in tooltips / disabled-day hints. */
export const WEEKEND_LABEL = "Weekend (Sat/Sun)";
